export default {
  computed: {
    dataBarCollection() {
      if (this.data.additional_data) {
        return {
          labels: this.getLabels(),
          datasets:[
            {
              data: this.getDataSets(),
              backgroundColor: this.getBackground(),
              hoverBackgroundColor: this.getBackground(),
              showLabel: this.showLabel,
            }]
        };
      }

      return {};
    }
  },
  methods: {
    getBackground() {
      let entries = Object.entries(this.data.additional_data.age);
      return entries.map(item => this.age[item[0]].color);
    },
    getDataSets() {
      let entries = Object.entries(this.data.additional_data.age);
      let summ = entries.reduce(function(sum, elem) {
        return sum + Number(elem[1].graph);
      }, 0);

      return entries.map(item => {
        if (Number(item[1].graph) === 0) {
          return 0;
        }
        return Math.round(Number(item[1].graph) / summ *100);
      });
    },
    getLabels() {
      const keys = Object.keys(this.data.additional_data.age);

      return keys.map(item => {
        const age = `${this.data.additional_data.age[item].start}-${this.data.additional_data.age[item].end}`;
        return age === '0-0' ? this.$t('feed.audit.age.body.unknown') : age;
      });
    }
  },
  data() {
    return {
      endTime: '23:59:59',
      lineOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: "bottom",
          labels: {
            boxWidth: 9,
            usePointStyle: true
          }
        },
        plugins: {
          datalabels: {
            display: (ctx) => {
              return ctx.dataset.showLabel;
            },
            formatter: (value) => {
              if (value === 0) {
                return "";
              }

              return value + '%';
            },
            anchor: "center",
            color: "#ffffff",
            font: {
              weight: "normal",
              size: 14,
              family: "Roboto"
            },
          },
        },
        tooltips: {
          backgroundColor: '#ffffff',
          titleFontFamily: "Roboto",
          titleFontStyle: "normal",
          titleFontColor: "#5E6D82",
          bodyFontFamily: "Roboto",
          bodyFontColor: "#5E6D82",
          borderColor: "#b3bccc",
          borderWidth: 1
        },
        hover: {mode: null},
      },
    };
  },
};
